var React = require('react');

function IconCollapseReversed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C0.894531 0 0 0.895508 0 2V14C0 15.1045 0.894531 16 2 16H14C15.1055 16 16 15.1045 16 14V2C16 0.895508 15.1055 0 14 0H2ZM12 7H4V9H12V7Z","fill":"currentColor"}));
}

IconCollapseReversed.defaultProps = {"viewBox":"0 0 16 16","fill":"none","style":{"color":"white"}};

module.exports = IconCollapseReversed;

IconCollapseReversed.default = IconCollapseReversed;
